import styled from 'styled-components';

export const StyledLayout = styled.div`
  .flexi-layout {
    min-width: 100%;
    max-width: 100%;
  }
`;
